
class FbdClassSelector {
   eGui;
   classId;

   init(params) {
      this.classId = params.data['class_id'];

      this.eGui = document.createElement('span');
      this.eGui.classList.add('class-title');

      const label = document.createElement('a');
      label.innerText = params.valueFormatted ? params.valueFormatted : params.value;
      label.href = `?class=${this.classId}`;

      this.eGui.appendChild(label);
   }

   getGui() {
      return this.eGui;
   }

   refresh(params) {
      return false;
   }

   destroy() {

   }
}

export default FbdClassSelector;